export class ShareUrl {
	static facebook(url, isPhone) {
		const fullUrl = `${url}?utm_source=facebook&utm_medium=share`;
		const encodedUrl = encodeURIComponent(fullUrl);
		window.open(`https://www.facebook.com/sharer.php?u=${encodedUrl}`, "_blank");
	}

	static twitter(url, isPhone) {
		const fullUrl = `${url}?utm_source=twitter&utm_medium=share`;
		const encodedUrl = encodeURIComponent(fullUrl);
		window.open(`https://x.com/intent/tweet?url=${encodedUrl}`, "_blank");
	}

	static whatsapp(url, isPhone) {
		const fullUrl = `${url}?utm_source=whatsapp&utm_medium=share`;
		const encodedUrl = encodeURIComponent(fullUrl);
		window.open(`https://api.whatsapp.com/send?text=${encodedUrl}`, "_blank");
	}

	static email(url, isPhone) {
		const fullUrl = `${url}?utm_source=email&utm_medium=share`;
		const encodedUrl = encodeURIComponent(fullUrl);
		window.open(`mailto:?body=${encodedUrl}`);
	}
}
